import React from 'react';
import { RouteAnalysis } from '../services/api';
import { formatVietnamCurrency } from '../utils/numberFormatter';
import { useLanguage } from '../contexts/LanguageContext';

interface CostComparisonProps {
  analysis: RouteAnalysis;
}

const CostComparison: React.FC<CostComparisonProps> = ({ analysis }) => {
  const { t } = useLanguage();
  
  if (!analysis?.costComparison) return null;

  const cc = analysis.costComparison;
  const hasSavings = cc.potentialTotalSavings > 0;

  return (
    <div className="card">
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">
  <i className="bi bi-calculator me-2"></i>
     {t('cost.comparison')}
        </h5>
      </div>
      <div className="card-body">
        <div className="row">
          {/* Actual Route */}
   <div className="col-md-6">
        <h6 className="text-danger">
              <span style={{ 
      display: 'inline-block', 
         width: '20px', 
          height: '4px', 
   backgroundColor: '#dc3545',
     marginRight: '8px',
        verticalAlign: 'middle'
   }}></span>
      {t('actual.route.gps')}
            </h6>
        <table className="table table-sm">
 <tbody>
          <tr>
       <td>{t('distance')}:</td>
              <td className="text-end fw-bold">{analysis.actualRoute?.distanceKm.toFixed(2)} km</td>
  </tr>
<tr>
         <td>{t('fuel.cost')}:</td>
     <td className="text-end">{formatVietnamCurrency(cc.actualFuelCost)}</td>
      </tr>
  <tr>
      <td>{t('toll.fee')}:</td>
          <td className="text-end">{formatVietnamCurrency(cc.actualTollFee)}</td>
    </tr>
     <tr className="table-active">
            <td><strong>{t('total.cost')}:</strong></td>
        <td className="text-end fw-bold">{formatVietnamCurrency(cc.actualTotalCost)}</td>
    </tr>
 </tbody>
            </table>
          </div>

          {/* Optimal Route */}
          <div className="col-md-6">
            <h6 className="text-success">
   <span style={{ 
              display: 'inline-block', 
            width: '20px', 
     height: '4px', 
                backgroundColor: '#28a745',
     marginRight: '8px',
         verticalAlign: 'middle',
  borderStyle: 'dashed'
    }}></span>
     {t('optimal.route.osrm')}
       </h6>
         <table className="table table-sm">
       <tbody>
       <tr>
        <td>{t('distance')}:</td>
   <td className="text-end fw-bold">{analysis.optimalRoute?.distanceKm.toFixed(2)} km</td>
         </tr>
         <tr>
        <td>{t('fuel.cost')}:</td>
      <td className="text-end">{formatVietnamCurrency(cc.optimalFuelCost)}</td>
      </tr>
   <tr>
              <td>{t('toll.fee')}:</td>
  <td className="text-end">{formatVietnamCurrency(cc.optimalTollFee)}</td>
  </tr>
                {analysis.optimalRoute?.averageSpeedLimitKmh && (
      <tr>
    <td>{t('avg.speed.limit')}:</td>
               <td className="text-end">
   <span className="badge bg-info">
     {analysis.optimalRoute.averageSpeedLimitKmh} km/h
        </span>
     </td>
   </tr>
 )}
         {analysis.optimalRoute?.maxSpeedLimitKmh && (
      <tr>
       <td>{t('max.speed.limit')}:</td>
        <td className="text-end">
      <span className="badge bg-warning">
          {analysis.optimalRoute.maxSpeedLimitKmh} km/h
   </span>
    </td>
           </tr>
        )}
    <tr className="table-active">
  <td><strong>{t('total.cost')}:</strong></td>
     <td className="text-end fw-bold">{formatVietnamCurrency(cc.optimalTotalCost)}</td>
      </tr>
          </tbody>
      </table>
          </div>
      </div>

        {/* Savings Summary */}
        <div className="row mt-4">
     <div className="col-12">
            <div className={`alert ${hasSavings ? 'alert-warning' : 'alert-success'}`}>
              <h6 className="alert-heading">
                <i className={`bi ${hasSavings ? 'bi-exclamation-triangle' : 'bi-check-circle'} me-2`}></i>
    {hasSavings ? t('potential.savings.identified') : t('efficient.route.taken')}
         </h6>
              <div className="row">
     <div className="col-md-4">
           <strong>{t('distance.difference')}:</strong><br />
        {cc.distanceDifferenceKm > 0 ? '+' : ''}{cc.distanceDifferenceKm.toFixed(2)} km
     ({cc.distanceDifferencePercentage > 0 ? '+' : ''}{cc.distanceDifferencePercentage.toFixed(1)}%)
     </div>
     <div className="col-md-4">
         <strong>{t('fuel.savings')}:</strong><br />
              {formatVietnamCurrency(cc.potentialFuelSavings)}
    </div>
     <div className="col-md-4">
             <strong>{t('total.savings')}:</strong><br />
<span className="fs-5 fw-bold">
{formatVietnamCurrency(cc.potentialTotalSavings)}
         </span>
     ({cc.savingsPercentage.toFixed(1)}%)
      </div>
       </div>
    </div>
    </div>
        </div>
      </div>
    </div>
  );
};

export default CostComparison;
